import { motion } from 'framer-motion'

import Img from './assets/sprites/Frame 5.webp'
import { useScrollingOrnament } from './useScrollingOrnament'

const SLIDES_COUNT = 13
const VIEWPORT_HEIGHT = 84
const OFFSET = 12

export const Ornament2 = () => {
  const { ref, slideNum } = useScrollingOrnament(
    SLIDES_COUNT,
    VIEWPORT_HEIGHT,
    OFFSET
  )

  return (
    <div ref={ref}>
      <svg viewBox="0 0 750 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="750" height="84" fill="#eae5df" />
        <motion.image href={Img} width="750" x="0" y={slideNum} />
      </svg>
    </div>
  )
}
